import calendarInlineCardComponent from './calendarInlineCard.component';

let calendarInlineCardModule = angular.module('vacations-absences.calendarInlineCard', [])

.component('calendarInlineCard', calendarInlineCardComponent)

.name;

export default calendarInlineCardModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlineCard/calendarInlineCard.js